module.exports = __webpack_public_path__ + "static/media/neon-dreams-lores.af202f13.jpg";